// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__1HRgo","formTitle":"style_formTitle__27jUP","errMsg":"style_errMsg__13bku"};